"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowProgress = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const react_native_svg_1 = __importStar(require("react-native-svg"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const ArrowBackground = ({ first, last, color, height, arrowSize, borderRadius: r, overlap, }) => {
    const [dimensions, setDimensions] = react_1.default.useState({ width: 0, height: 0 });
    const onLayout = (e) => {
        const { width, height: h } = e.nativeEvent.layout;
        if (width !== dimensions.width || h !== dimensions.height) {
            setDimensions({ width, height: h });
        }
    };
    const { width } = dimensions;
    if (width <= 0) {
        return (0, jsx_runtime_1.jsx)(react_native_1.View, { style: react_native_1.StyleSheet.absoluteFill, onLayout: onLayout });
    }
    const drawWidth = width + (last ? 0 : overlap);
    const radius = Math.min(r, height / 2);
    const arrow = Math.min(arrowSize, drawWidth / 2);
    let d;
    if (first && last) {
        d = `
            M ${radius},0
            L ${drawWidth - radius},0
            A ${radius} ${radius} 0 0 1 ${drawWidth},${radius}
            L ${drawWidth},${height - radius}
            A ${radius} ${radius} 0 0 1 ${drawWidth - radius},${height}
            L ${radius},${height}
            A ${radius} ${radius} 0 0 1 0,${height - radius}
            L 0,${radius}
            A ${radius} ${radius} 0 0 1 ${radius},0
            Z
        `;
    }
    else if (first) {
        d = `
            M ${radius},0
            L ${drawWidth - arrow},0
            L ${drawWidth},${height / 2}
            L ${drawWidth - arrow},${height}
            L ${radius},${height}
            A ${radius} ${radius} 0 0 1 0,${height - radius}
            L 0,${radius}
            A ${radius} ${radius} 0 0 1 ${radius},0
            Z
        `;
    }
    else if (last) {
        d = `
            M 0,0
            L ${drawWidth - radius},0
            A ${radius} ${radius} 0 0 1 ${drawWidth},${radius}
            L ${drawWidth},${height - radius}
            A ${radius} ${radius} 0 0 1 ${drawWidth - radius},${height}
            L 0,${height}
            L ${arrow},${height / 2}
            Z
        `;
    }
    else {
        d = `
            M 0,0
            L ${drawWidth - arrow},0
            L ${drawWidth},${height / 2}
            L ${drawWidth - arrow},${height}
            L 0,${height}
            L ${arrow},${height / 2}
            Z
        `;
    }
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: react_native_1.StyleSheet.absoluteFill, onLayout: onLayout, children: (0, jsx_runtime_1.jsx)(react_native_svg_1.default, { width: drawWidth, height: height, viewBox: `0 0 ${drawWidth} ${height}`, style: { position: 'absolute', left: 0, top: 0, right: -overlap, bottom: 0 }, children: (0, jsx_runtime_1.jsx)(react_native_svg_1.Path, { d: d, fill: color }) }) }));
};
const ArrowProgress = ({ items, height = 52, arrowSize = 18, separatorWidth = 3, separatorColor: customSeparatorColor, borderRadius = 8, completeColor: customCompleteColor, completeTextColor: customCompleteTextColor, inProgressColor: customInProgressColor, inProgressTextColor: customInProgressTextColor, incompleteColor: customIncompleteColor, incompleteTextColor: customIncompleteTextColor, showCheckIconForComplete = false, style, }) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const separatorColor = customSeparatorColor ?? THEME.CardBackground;
    const completeColor = customCompleteColor ?? `${THEME.SecondaryLight}88`;
    const completeTextColor = customCompleteTextColor ?? THEME.Text;
    const inProgressColor = customInProgressColor ?? `${THEME.Salmon}`;
    const inProgressTextColor = customInProgressTextColor ?? THEME.AlwaysWhite;
    const incompleteColor = customIncompleteColor ?? `${THEME.CoolGray}22`;
    const incompleteTextColor = customIncompleteTextColor ?? `${THEME.Text}`;
    const overlap = Math.max(0, arrowSize - separatorWidth);
    const getItemColors = (item) => {
        const status = item.status ?? 'incomplete';
        switch (status) {
            case 'complete':
                return { bg: completeColor, text: completeTextColor };
            case 'inprogress':
                return { bg: inProgressColor, text: inProgressTextColor };
            case 'incomplete':
            default:
                return { bg: incompleteColor, text: incompleteTextColor };
        }
    };
    if (items.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [
            styles.wrapper,
            {
                height,
                backgroundColor: separatorColor,
                borderRadius,
            },
            style,
        ], children: items.map((item, index) => {
            const first = index === 0;
            const last = index === items.length - 1;
            const { bg: backgroundColor, text: textColor } = getItemColors(item);
            return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [
                    styles.step,
                    {
                        flex: 1,
                        marginRight: last ? 0 : -overlap,
                        zIndex: items.length - index,
                    },
                ], children: [(0, jsx_runtime_1.jsx)(ArrowBackground, { first: first, last: last, color: backgroundColor, height: height, arrowSize: arrowSize, borderRadius: borderRadius, overlap: overlap }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [
                            styles.content,
                            {
                                paddingLeft: 10 + (first ? arrowSize : separatorWidth + arrowSize),
                                paddingRight: 10 + (last ? arrowSize : separatorWidth + arrowSize),
                            },
                        ], children: [showCheckIconForComplete && item.status === "complete" && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.iconContainer, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.CircleCheck, color: THEME.Secondary, size: 12 }) })), (0, jsx_runtime_1.jsx)(react_native_1.Text, { numberOfLines: 2, ellipsizeMode: "tail", style: [
                                    styles.label,
                                    {
                                        color: textColor,
                                        fontSize: 12,
                                        lineHeight: 16,
                                    },
                                ], children: item.label })] })] }, item.key));
        }) }));
};
exports.ArrowProgress = ArrowProgress;
const styles = react_native_1.StyleSheet.create({
    wrapper: {
        width: "100%",
        flexDirection: "row",
        alignItems: "stretch",
        overflow: "hidden",
    },
    step: {
        position: "relative",
        minWidth: 0,
    },
    content: {
        flex: 1,
        minWidth: 0,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        gap: 6,
    },
    label: {
        textAlign: "center",
        ...react_native_1.Platform.select({
            web: {
                wordBreak: "keep-all",
                overflowWrap: "normal",
            },
        }),
    },
    iconContainer: {
        flexShrink: 0,
        alignItems: "center",
        justifyContent: "center",
    },
});
